import { reactify } from '@zeiss/zui-react';
export const ZuiIconMedAcquireSection1X = reactify('zui-icon-med-acquire-section-1-x');
